export const queryKeys = {
  me: ["auth", "me"] as const,
  apiTokens: ["account", "api-tokens"] as const,
  orgs: ["orgs"] as const,
  members: (org: string) => ["orgs", org, "members"] as const,
  projects: (org: string) => ["orgs", org, "projects"] as const,
  project: (org: string, project: string) => ["orgs", org, "projects", project] as const,
  activity: (org: string, project: string) => ["orgs", org, "projects", project, "activity"] as const,
  questionnaire: (org: string, project: string) => ["orgs", org, "projects", project, "questionnaire"] as const,
  questionnaireVersions: (org: string, project: string) =>
    ["orgs", org, "projects", project, "questionnaire", "versions"] as const,
  questionnaireVersion: (org: string, project: string, v: number) =>
    ["orgs", org, "projects", project, "questionnaire", "versions", v] as const,
  files: (org: string, project: string) => ["orgs", org, "projects", project, "files"] as const,
  feedback: (org: string, project: string) => ["orgs", org, "projects", project, "feedback"] as const,
  prototypeBatches: (org: string, project: string) => ["orgs", org, "projects", project, "prototype-batches"] as const,
  admin: {
    orgs: (q: string) => ["admin", "orgs", q] as const,
    org: (id: string) => ["admin", "org", id] as const,
    project: (id: string) => ["admin", "project", id] as const,
    prototypeShares: (id: string) => ["admin", "project", id, "prototype-shares"] as const,
    prototypeBatches: (id: string) => ["admin", "project", id, "prototype-batches"] as const,
    projects: (status: string, orgId: string) => ["admin", "projects", status, orgId] as const,
    users: (q: string) => ["admin", "users", q] as const,
    responsesCompare: (id: string) => ["admin", "project", id, "responses", "compare"] as const,
    settings: ["admin", "settings"] as const,
    authEvents: (userId: string) => ["admin", "user", userId, "auth-events"] as const,
  },
};
